/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateVariantRequest } from '../models/CreateVariantRequest';
import type { MaskUpdateRequest } from '../models/MaskUpdateRequest';
import type { RoutingComparisonResult } from '../models/RoutingComparisonResult';
import type { RoutingDto } from '../models/RoutingDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoutingControllerService {
    /**
     * @param uuid
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/routings/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: RoutingDto,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/routings/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/routings/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<RoutingDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/routings',
        });
    }
    /**
     * @param requestBody
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: RoutingDto,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/routings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param defaultUuid
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static listVariantsForDefault(
        defaultUuid: string,
    ): CancelablePromise<Array<RoutingDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/routings/{defaultUuid}/variants',
            path: {
                'defaultUuid': defaultUuid,
            },
        });
    }
    /**
     * @param defaultUuid
     * @param requestBody
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static createVariantFromDefault(
        defaultUuid: string,
        requestBody: CreateVariantRequest,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/routings/{defaultUuid}/variants',
            path: {
                'defaultUuid': defaultUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param variantUuid
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static promoteVariantToDefault(
        variantUuid: string,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/routings/variants/{variantUuid}/promote',
            path: {
                'variantUuid': variantUuid,
            },
        });
    }
    /**
     * @param requestBody
     * @param mode
     * @param confirmOverwrite
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static importRouting(
        requestBody: RoutingDto,
        mode: 'CLONE' | 'OVERWRITE' = 'CLONE',
        confirmOverwrite?: boolean,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/routings/import',
            query: {
                'mode': mode,
                'confirmOverwrite': confirmOverwrite,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns RoutingComparisonResult OK
     * @throws ApiError
     */
    public static previewImport(
        requestBody: RoutingDto,
    ): CancelablePromise<RoutingComparisonResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/routings/import/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param variantUuid
     * @param requestBody
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static updateVariantMask(
        variantUuid: string,
        requestBody: MaskUpdateRequest,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/routings/variants/{variantUuid}/mask',
            path: {
                'variantUuid': variantUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param search
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static searchRoutings(
        search?: string,
    ): CancelablePromise<Array<RoutingDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/routings/search',
            query: {
                'search': search,
            },
        });
    }
    /**
     * @param materialId
     * @returns RoutingDto OK
     * @throws ApiError
     */
    public static getActiveRoutingForMaterial(
        materialId: string,
    ): CancelablePromise<RoutingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/routings/active/material/{materialId}',
            path: {
                'materialId': materialId,
            },
        });
    }
}
